import { render, staticRenderFns } from "./WebpartHeader.vue?vue&type=template&id=16374d34"
import script from "./WebpartHeader.vue?vue&type=script&lang=ts"
export * from "./WebpartHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports